<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.buyerStats')" :title="$t('nav.buyerStats')">
      <div class="list__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('languages', [])"
              v-if="filterData.languages.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.languages.length > 0">
                  {{ filterData.languages[0].code }}

                  <template v-if="filterData.languages.length > 1">
                    +{{ filterData.languages.length - 1 }}
                  </template>
                </template>
                <template v-else> Languages </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_languages" placeholder="Search Languages" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.languages"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('languages', item)"
                  >
                    {{ item.code }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('languages', item)"
                  v-for="item in getCheckList(
                    'languagesList',
                    'search_languages',
                    'code',
                    'languages',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.code }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('direction', [])"
              v-if="filterData.direction.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.direction.length > 0">
                  {{ filterData.direction[0].name }}

                  <template v-if="filterData.direction.length > 1">
                    +{{ filterData.direction.length - 1 }}
                  </template>
                </template>
                <template v-else> Direction </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.direction"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('direction', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('direction', item)"
                  v-for="item in directionList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration_type', [])"
              v-if="filterData.integration_type.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.integration_type.length > 0">
                  {{ filterData.integration_type[0].name }}

                  <template v-if="filterData.integration_type.length > 1">
                    +{{ filterData.integration_type.length - 1 }}
                  </template>
                </template>
                <template v-else> Integration Type </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.integration_type"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration_type', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('integration_type', item)"
                  v-for="item in integrationSpecialTypeList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.date_from" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.date_to" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
      </div>

      <div class="list">
        <div v-for="team in list" :key="team.id">
          <div class="list__table-title">{{ team.team.name }}</div>
          <CustomTable
            v-if="team['metrics-by-user'].length"
            :data="team['metrics-by-user']"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
            :noSortColumn="tableOptions.noSortColumn"
            :name="'buyerDeposit'"
          >
            <template v-slot:extra>
              <div class="custom-table__row row-total total">
                <div class="custom-table__row-item"><b>Total</b></div>
                <div class="custom-table__row-item"></div>
                <div class="custom-table__row-item">
                  {{ team.metrics.leads }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.cpl }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.cr_leads }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.cr_mtm }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.ftd }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.ftd_mtm }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.ftd_cost }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.ftd_cost_mtm }}
                </div>
                <div class="custom-table__row-item">
                  {{ team.metrics.spent }}
                </div>
              </div>
            </template>
          </CustomTable>
        </div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainSelect from "~/components/atoms/inputs/MainSelect.vue";

export default {
  name: "BuyerDeposit",
  metaInfo() {
    return {
      title: this.$t("nav.buyerStats"),
    };
  },
  data() {
    return {
      list: [],
      data: {},
      directionSort: false,
      orderSort: "id",

      search_integration: "",
      search_client: "",
      search_countries: "",
      search_languages: "",

      filterData: {
        date_from: null,
        date_to: null,
        languages: [],
        direction: [],
        integration_type: [],
      },
      isFilter: false,
      clientList: [],
      integrationList: [],
      countriesList: [],
      languagesList: [],

      tableOptions: {
        deletedKeys: ["null"],
        isActionBlockVisible: true,
        noSortColumn: [],
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },
          {
            from: "leads",
            to: "Leads",
          },
          {
            from: "cpl",
            to: "CPL",
          },
          {
            from: "cr_leads",
            to: "CR Leads",
          },
          {
            from: "cr_mtm",
            to: "Cr MtM",
          },
          {
            from: "ftd",
            to: "FTD",
          },
          {
            from: "ftd_cost",
            to: "FTD Cost",
          },
          {
            from: "ftd_cost_mtm",
            to: "FTD Cost MtM",
          },
          {
            from: "ftd_mtm",
            to: "FTD MtM",
          },
          {
            from: "spent",
            to: "Spent",
          },
        ],
        customOrder: [
          "id",
          "name",
          "leads",
          "cpl",
          "cr_leads",
          "cr_mtm",
          "ftd",
          "ftd_mtm",
          "ftd_cost",
          "ftd_cost_mtm",
          "spent",
        ],
      },

      directionList: [
        {
          name: this.$t("region.europe"),
          id: "eu",
        },
        {
          name: this.$t("region.australia"),
          id: "au",
        },
        {
          name: this.$t("region.canada"),
          id: "ca",
        },
      ],

      integrationSpecialTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "In",
          id: "in",
        },
        {
          name: "Out",
          id: "out",
        },
      ],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    // Pagination,
    ModalError,
    // MainSelect,
    DatePicker,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);
    this.getLanguage();
    this.setQueryParams();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess"]),
    page() {
      return +this.$route.params.page;
    },
    getQueryParameters() {
      const query = this.$route.fullPath.split("?")[1];
      if (query) {
        return `?${query}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    getCheckList(listKey, filterKey, nameKey, chooseItem) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      // список выбранных id
      const selectedIds = Array.isArray(this.filterData[chooseItem])
        ? this.filterData[chooseItem].map((item) => item?.id)
        : [];

      const filterStr =
        rawFilter == null || String(rawFilter).trim() === ""
          ? null
          : String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        // ❌ исключаем если id уже выбран
        if (selectedIds.includes(item?.id)) return false;

        // если фильтра нет — возвращаем всё кроме выбранных
        if (!filterStr) return true;

        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList() {
      let url = `?page=${this.page}`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      const data = {
        parameters: {},
      };

      if (this.filterData.languages.length > 0) {
        const ids = this.filterData.languages;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.language_id = idsArray;
      }

      if (this.filterData.direction.length > 0) {
        const ids = this.filterData.direction;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.direction = idsArray;
      }

      if (this.filterData.integration_type.length > 0) {
        const ids = this.filterData.integration_type;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.integration_type = idsArray;
      }

      if (this.filterData.date_from) {
        data.parameters.created_at_from = moment(this.filterData.date_from).format("YYYY-MM-DD");
      }

      if (this.filterData.date_to) {
        data.parameters.created_at_to = moment(this.filterData.date_to).format("YYYY-MM-DD");
      }

      this.$store.commit("lead/setLoading", true);

      leadApi
        .getBuyerDeposit(url, data)
        .then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});

          const teams = res.data.items;

          this.list = teams;
        })
        .catch((error) => {
          const { data } = error.response;
          console.log(error);
          this.$store.commit("lead/setError", data);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },

    async getLanguage() {
      await leadApi
        .getLanguageList()
        .then((res) => {
          this.languagesList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    filterList() {
      this.isFilter = true;
      this.handleSetQueryParams();
    },

    handleSetQueryParams() {
      const filter = {};

      if (this.filterData.languages.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.languages.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.code);
        });

        filter.languages = ids.join(",");
        filter.languages_name = name.join(",");
      }

      if (this.filterData.direction.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.direction.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.direction = ids.join(",");
        filter.direction_name = name.join(",");
      }

      if (this.filterData.integration_type.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.integration_type.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.integration_type = ids.join(",");
        filter.integration_type_name = name.join(",");
      }

      if (this.filterData.date_from != null) {
        filter.date_from = moment(this.filterData.date_from).format("YYYY-MM-DD");
      }

      if (this.filterData.date_to != null) {
        filter.date_to = moment(this.filterData.date_to).format("YYYY-MM-DD");
      }

      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.BUYER_DEPOSIT.replace(":page", 1),
        });
      }
      this.$router.push({ name: "BuyerDeposit", query: filter });
    },
    setQueryParams() {
      if (this.handleGetQueryParam("languages")) {
        const ids = this.handleGetQueryParam("languages").split(",");
        const names = this.handleGetQueryParam("languages_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.languages.push({
            id: ids[index],
            code: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("direction")) {
        const ids = this.handleGetQueryParam("direction").split(",");
        const names = this.handleGetQueryParam("direction_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.direction.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("integration_type")) {
        const ids = this.handleGetQueryParam("integration_type").split(",");
        const names = this.handleGetQueryParam("integration_type_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.integration_type.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("date_from")) {
        this.filterData.date_from = moment(
          this.handleGetQueryParam("date_from"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("date_to")) {
        this.filterData.date_to = moment(
          this.handleGetQueryParam("date_to"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      this.getList();
    },
    handleGetQueryParam(param) {
      if (this.$route.query[param] != undefined) {
        return this.$route.query[param];
      } else {
        return null;
      }
    },

    filterListReset() {
      this.isFilter = false;
      this.$router.push({ name: "BuyerDeposit", query: {} });
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.BUYER_DEPOSIT.replace(":page", 1),
        });
      }
      this.filterData.date_from = null;
      this.filterData.date_to = null;
      this.filterData.languages = [];
      this.filterData.direction = [];
      this.filterData.integration_type = [];

      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },

    addCheckElement(key, value) {
      const foundObj = this.filterData[key].find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.filterData[key].push(value);
      }
    },
    removeCheckElement(key, value) {
      this.filterData[key] = this.filterData[key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset) {
      console.log("hello");
      this.filterData[key] = reset;
    },
  },
};
</script>

<style lang="scss" scoped>
.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 10;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  display: grid;
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 2fr 1fr 1fr !important;
}

/deep/.modal-container {
  height: fit-content;
  max-height: 90vh;
  overflow-y: auto;
}

.list {
  &__table-title {
    padding: 20px 0 10px;
    font-size: 24px;
    font-weight: 700;
  }
  &__filter-favorite {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    font-size: 18px;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }

    .inner {
      fill: #fff !important;
    }
    .border {
      stroke: rgb(148, 22, 22) !important;
      fill: none !important;
    }

    &.active {
      .inner {
        fill: rgb(148, 22, 22) !important;
      }
    }
  }
  &__confirm-log {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid gainsboro;
    margin-bottom: 10px;
  }

  &__confirm-log-type {
    padding: 20px;
    background: gainsboro;
    border-radius: 10px;
    margin-right: 10px;
  }

  &__confirm-log-time {
    margin-left: auto;
    padding-left: 10px;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
